import $ from 'jquery';

$(document.body).on('click', '.js-close-flash-notification', function () {
	const $flashNotification = $(this).parent('.flash-notification');
	$flashNotification.addClass('hidden');
	setTimeout(() => $flashNotification.remove(), 300);
});
